import React from 'react';

export default function PatientFiles() {
  return <>Medical Files</>;
}
